import React from "react";

//  Style \\
import "../../assets/styles/sections/contactSection.scss";

//  Icons \\
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { MdOutlineMailOutline } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";
import { BsClock } from "react-icons/bs";

const ContactSection = () => {
  return (
      <section className="contact">
        <div className="containers">
          <div className="contact_items">
            <div className="contact_items_title">
              <h3>Get in touch</h3>
              <p>Contact</p>
            </div>

            <div className="contact_items_cardBox">
              <div className="cards">
                <div className="card_items">
                  <div className="card_items_icons">
                    <LiaPhoneVolumeSolid className="icons" />
                  </div>

                  <div className="card_items_title">
                    <h4>Emergency</h4>
                  </div>

                  <div className="card_items_tel">
                    <p>(237) 681-812-255</p>
                    <p>(237) 666-331-894</p>
                  </div>
                </div>
              </div>

              <div className="cards">
                <div className="card_items">
                  <div className="card_items_icons">
                    <CiLocationOn className="icons" />
                  </div>

                  <div className="card_items_title">
                    <h4>Location</h4>
                  </div>

                  <div className="card_items_tel">
                    <p>0123 Some place</p>
                    <p>9876 Some country</p>
                  </div>
                </div>
              </div>

              <div className="cards">
                <div className="card_items">
                  <div className="card_items_icons">
                    <MdOutlineMailOutline className="icons" />
                  </div>

                  <div className="card_items_title">
                    <h4>Email</h4>
                  </div>

                  <div className="card_items_tel">
                    <p>fildineeesoe@gmil.com</p>
                    <p>myebstudios@gmail.com</p>
                  </div>
                </div>
              </div>

              <div className="cards">
                <div className="card_items">
                  <div className="card_items_icons">
                    <BsClock className="icons" />
                  </div>

                  <div className="card_items_title">
                    <h4>Working Hours</h4>
                  </div>

                  <div className="card_items_tel">
                    <p>Mon-Sat 09:00-20:00</p>
                    <p>Sunday Emergency only</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default ContactSection;
